import React, { useEffect, useState } from "react";
import {
  FButton,
  FSider,
  FSiderItem,
  FSiderSubMenuItem,
  FTypo,
} from "ferrum-design-system";
import { getIcon } from "./SidebarConfig";
import { getSideMenuForAssociatedOrganizationBySiteName } from "../../_apis/OrganizationCrud";
import { useSelector } from "react-redux";
import {
  IS_MULTISWAP,
  isGateWaySite,
  isIncludedInRestrictedSiteList,
} from "../../utils/const.utils";
import { chainData } from "../../utils/constants";
import { RootState } from "../../redux/rootReducer";
import ferrumLogo from "../../assets/ms-new-images/Ferrum-Network-logo.png";
import MultiSwapLogo from "../../assets/ms-new-images/icons/ms-logo-icon.png";
import FaqsIcon from "../../assets/img/FAQ.svg";
import DocsIcon from "../../assets/img/DOCS.svg";
import ProductTourIcon from "../../assets/img/PRODUCT-TOUR.svg";

// import DiscordIcon from "../../assets/img/discord-icon.svg";
import { addNetworkToMetamask } from "../../utils/web3/Web3Helper";
import { ThemeProvider, createGlobalStyle } from "styled-components";

const DashboardSidebar = () => {
  const [sideMenuItems, setSideMenuItems] = useState();
  const { tokenV2, theme } = useSelector((state: RootState) => ({
    ...state.walletAuthenticator,
    ...state.config,
  }));

  useEffect(() => {
    getSideMenuInformation(tokenV2);
    // eslint-disable-next-line
  }, [tokenV2]);

  const getCurrenciesAgainstOrganization = (currencies: any) => {
    let currencyArray: any = [];
    currencies.length &&
      currencies.forEach((item: any) => {
        currencyArray.push({
          title: `Buy ${item.currency.symbol}`,
          icon: item.icon && getIcon(item.icon),
          target: "_blank",
          path: `${item?.currency?.currencyAddressesByNetwork[0]?.networkDex?.dex?.url}swap?inputCurrency=BNB&outputCurrency=${item?.currency?.currencyAddressesByNetwork[0]?.tokenContractAddress}&exactField=output&exactAmount=`,
          id: item._id,
        });
      });
    return currencyArray;
  };

  const getSubMenuItemMenu = (item: any) => {
    let subMenuItemArray: any = [];
    let children: any = [];
    item.menuItems.forEach((subMenuItem: any) => {
      children.push({
        title: subMenuItem.name,
        icon: subMenuItem.icon && getIcon(subMenuItem.icon),
        path: `${subMenuItem.path}`,
        id: subMenuItem._id,
      });
    });
    subMenuItemArray.push({
      title: item.name,
      icon: item.icon && getIcon(item.icon),
      path: item.path,
      children: children,
      id: item._id,
    });
    return subMenuItemArray;
  };

  const getMenuItemInfoFromMetaData = (item: any) => {
    let menuItem: any = [];
    let externalPathData = item.metaData.find(
      (x: any) => x.key === "externalDynamicPath"
    );
    const pathOverride =
      !theme?.crucibleConfig?.isDashboardEnabled && item?.name === "Home"
        ? "/dashboard/crucible"
        : undefined;
    if (externalPathData.value) {
      menuItem.push({
        title: item.name,
        icon: item.icon && getIcon(item.icon),
        path: pathOverride || externalPathData.value,
        id: item._id,
        target: "_blank",
      });
    } else {
      let internalPathData = item.metaData.find(
        (x: any) => x.key === "internalStaticPath"
      );
      menuItem.push({
        title: item.name,
        icon: item.icon && getIcon(item.icon),
        path: pathOverride || internalPathData.value,
        id: item._id,
      });
    }

    return menuItem;
  };

  const getSideMenuAgainstOrganization = (sideMenuItems: any) => {
    const { menu } = sideMenuItems;
    let sideMenuArray: any = [];
    menu &&
      menu.length &&
      menu.forEach((item: any) => {
        if (IS_MULTISWAP && item.tags.includes("multiswap")) {
          // if (!item.tags.includes("#competitions")) {
          if (item.tags.includes("currencies")) {
            let currencies = getCurrenciesAgainstOrganization(item.menuItems);
            if (currencies.length && currencies.length > 1) {
              sideMenuArray.push({
                title: "Get Token",
                path: "",
                icon: item.icon && getIcon(item.icon),
                id: item._id,
                children: currencies,
              });
            } else {
              sideMenuArray.push(...currencies);
            }
          } else if (item.menuItems.length > 0) {
            let subMenuItemMenu = getSubMenuItemMenu(item);
            sideMenuArray.push(...subMenuItemMenu);
          } else {
            let menuItem = getMenuItemInfoFromMetaData(item);
            sideMenuArray.push(...menuItem);
          }
        } else if (!IS_MULTISWAP) {
          if (item.tags.includes("currencies")) {
            let currencies = getCurrenciesAgainstOrganization(item.menuItems);
            if (
              currencies.length &&
              currencies.length > 1 &&
              isIncludedInRestrictedSiteList(window.location.host)
            ) {
              sideMenuArray.push({
                title: currencies[0].title,
                target: "_blank",
                path: theme?.crucibleConfig?.baseCurrency?.dexLink
                  ? theme?.crucibleConfig?.baseCurrency?.dexLink
                  : `${currencies[0]?.currency?.currencyAddressesByNetwork[0]?.networkDex?.dex?.url}swap?inputCurrency=BNB&outputCurrency=${currencies[0]?.currency?.currencyAddressesByNetwork[0]?.tokenContractAddress}&exactField=output&exactAmount=`,
                icon: currencies[0].icon,
                id: currencies[0]._id,
              });
            } else if (currencies.length && currencies.length > 1) {
              sideMenuArray.push({
                title: "Get Token",
                path: "",
                icon: item.icon && getIcon(item.icon),
                id: item._id,
                children: currencies,
              });
            } else {
              sideMenuArray.push(...currencies);
            }
          } else if (item.menuItems.length > 0) {
            let subMenuItemMenu = getSubMenuItemMenu(item);
            sideMenuArray.push(...subMenuItemMenu);
          } else {
            let menuItem = getMenuItemInfoFromMetaData(item);
            sideMenuArray.push(...menuItem);
          }
        }
      });
    return sideMenuArray;
  };

  const getSideMenuInformation = async (token: any) => {
    try {
      let response = await getSideMenuForAssociatedOrganizationBySiteName(
        window.location.host,
        token,
        isGateWaySite()
      );
      let sideMenuItems = response && response.data && response.data.body;
      let productList = getSideMenuAgainstOrganization(sideMenuItems);
      setSideMenuItems(productList);
    } catch (e: any) {
      // console.log(`Error occured: ${e?.response?.data?.status?.message}`);
    }
  };

  const handleToggle = (e: any, index: any, item: any) => {
    let el = document.getElementById(index);
    if (el && e.target.textContent === item.title) {
      let childEl = el.getElementsByClassName("submenu-open");
      if (childEl && childEl[0]) {
        let data = childEl[0];
        const classes = data.classList;
        setTimeout(() => {
          classes.remove("submenu-open");
        }, 100);
      }
    }
  };

  const renderContent = (items: any) => {
    return items.map((item: any, index: any) => {
      return (
        <div id={index} onClick={(e: any) => handleToggle(e, index, item)}>
          <FSiderItem
            to={item.path}
            title={item.title}
            prefix={item.icon}
            key={item.id}
            target={item.target && item.target}
          >
            {item?.children?.length ? (
              <FSiderSubMenuItem>
                {item.children.map((subItem: any, index: number) => {
                  return (
                    <FSiderItem
                      key={index}
                      to={subItem.path}
                      title={subItem.title}
                      prefix={
                        subItem.icon ? (
                          subItem.icon
                        ) : (
                          <img
                            src="/ferrum/bullet.png"
                            className="side-menu-img"
                            alt="side menu item"
                          />
                        )
                      }
                      target={subItem.target && subItem.target}
                    />
                  );
                })}
              </FSiderSubMenuItem>
            ) : (
              ""
            )}
          </FSiderItem>
        </div>
      );
    });
  };

  const GlobalStyles = createGlobalStyle`
  .f-sider-outer {
   background: ${theme?.menuBackgroundColor} !important;
  .desktop-aside-toggler {
    background: ${theme?.colors?.primary} !important;
    border-color: ${theme?.colors?.primary} !important;
  }
   .f-sider{ 
    .f-sider-items { 
      .f-sider-item {
        .f-item-link { 
          .f-item-text {
            color:${theme?.colors?.primaryLight}!important;
          }
        }
        .f-item-link:hover { 
          .f-item-text{
            color:${theme?.colors?.primary}!important;
          }
        }
      }
    }
  }
  .f-sider{ 
    .f-sider-items{ 
      .f-sider-item {
        .f-item-link:hover{ 
          .f-item-icon:first-child img:hover{
           background: ${theme?.colors?.primary}!important;
          }
        }
      }
    }           
}
`;

  return (
    <ThemeProvider theme={theme}>
      <FSider
        siderLogo={IS_MULTISWAP ? MultiSwapLogo : theme?.logo || ferrumLogo}
      >
        {sideMenuItems && renderContent(sideMenuItems)}
        <div className="extra-menu-items f-mt-2">
          <hr className="horizontal-line" />
          {IS_MULTISWAP ? (
            <>
              <FSiderItem
                className={"faq-link"}
                to={
                  "https://help.ferrumnetwork.io/en/collections/7390176-multiswap"
                }
                title={"FAQS"}
                prefix={<img src={FaqsIcon} alt="faqs" />}
                target={"_blank"}
              />
              <FSiderItem
                className={"docs-link"}
                to={
                  "https://docs.ferrumnetwork.io/ferrum-network-ecosystem/v/multiswap-and-multichain-liquidity-pool-bridge/"
                }
                title={"DOCS"}
                prefix={<img src={DocsIcon} alt="faqs" />}
                target={"_blank"}
              />
              {/* <FSiderItem
                className={"guide-link"}
                target={"_self"}
                to={`/swap?product_tour_id=497014`}
                title={"PRODUCT TOUR"}
                prefix={<img src={ProductTourIcon} alt="faqs" />}
              />
              <FSiderItem
                to={"https://discord.com/invite/TfrWeN8Vtq"}
                title={"DISCORD SUPPORT"}
                prefix={<img src={DiscordIcon} alt="discord support" />}
                target={"_blank"}
              /> */}
            </>
          ) : null}
        </div>
        {!IS_MULTISWAP && theme.type === "ferrum" ? (
          <div className="add-to-metamask-banner">
            <div>
              <FTypo size={20} className={"text f-pt--5 f-pb--5"}>
                Using Arbitrum ?
              </FTypo>
              <FButton
                title={"Add Chainstack RPC to MetaMask"}
                className="add-to-metamask font-size-12"
                onClick={() => addNetworkToMetamask(chainData["ARBITRUM"])}
              />
            </div>
          </div>
        ) : null}
      </FSider>
      <GlobalStyles />
    </ThemeProvider>
  );
};

export default DashboardSidebar;
